export const setGrupoPerguntas = (context, payload) => {
    context.commit('setGrupoPerguntas', payload)
};